import axios from 'axios'
import Cookies from 'js-cookie';
const getServerURL = require('./get-server-url').default

const Axios = axios.create({
  baseURL: getServerURL(),
  withCredentials: true
})

const handleLogout = () => {
  Axios({
    method: 'post',
    url: '/api/sso/v1/users/logout'
  })
    .then(() => {
      Cookies.remove('ut', { path: '/', secure: true });
      localStorage.removeItem("user")
      localStorage.removeItem("general_setting")
    })
    .catch((err) => {
      console.error(err)
    })
}

Axios.interceptors.response.use(undefined, error => {
  // whatever you want to do with the error
  const token = Cookies.get("ut")
  const user = JSON.parse(localStorage.getItem("user"))

  let errMsg = error.response.data.message
  if (
      (token && 
        (errMsg === 'Session expired' || errMsg === 'Invalid token' || errMsg === 'invalid signature')
      ) || 
      (token &&
        !user?.role_id &&
        errMsg === 'Forbidden'
      )
    ) {
    handleLogout()
  }

  throw error;
});

export default Axios
